import { createReducer } from '@reduxjs/toolkit';
import { getAboutUsPage } from '../actions/aboutPage';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getAboutUsPage.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  }));
});
